import { render, staticRenderFns } from "./WelcomeModel.vue?vue&type=template&id=2b2aca7e&scoped=true"
import script from "./WelcomeModel.vue?vue&type=script&lang=js"
export * from "./WelcomeModel.vue?vue&type=script&lang=js"
import style0 from "./WelcomeModel.vue?vue&type=style&index=0&id=2b2aca7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2aca7e",
  null
  
)

export default component.exports